module.exports = __webpack_public_path__ + "static/media/pic3.8d9838ac.jpg";